export default "__VITE_ASSET__CYfJ8Ava__"